module.exports = __webpack_public_path__ + "static/media/google_09.0c5b8dfc.svg";